import { render, staticRenderFns } from "./Partida.vue?vue&type=template&id=5ce92b84&scoped=true&"
import script from "./Partida.vue?vue&type=script&lang=js&"
export * from "./Partida.vue?vue&type=script&lang=js&"
import style0 from "./Partida.vue?vue&type=style&index=0&id=5ce92b84&lang=scss&scoped=true&"
import style1 from "./Partida.vue?vue&type=style&index=1&id=5ce92b84&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce92b84",
  null
  
)

export default component.exports